import { connect } from 'react-redux';
import Checklist from '../../../../components/AnnualPlanning/SecondTerm/Checklist.tsx';
import { RootState } from '@/core/types/state';
import {
  currentVersion,
  checklists,
  isLoadingChecklists,
  checklistsErrorMessage,
  currentFulfillmentVersion,
  readOnlyMode,
  periods,
  selectedYear,
  scopeName,
  enterpriseName,
  currentBusinessUnit,
} from '@/core/selectors';
import {
  uploadChecklistAnswerEvidenceAction,
  resolveChecklistAnswerEvidenceAction,
} from '@/core/slices/checklists';
import {
  fetchAnnualPlanComplianceContext,
  getPlanValidation,
  markFulfillmentVersionForApproval,
} from '@/core/slices/plans';

const ConnectedChecklist = connect(
  (state: RootState) => ({
    currentVersion: currentVersion(state),
    currentFulfillmentVersion: currentFulfillmentVersion(state),
    checklists: checklists(state),
    isLoading: isLoadingChecklists(state),
    errorMessage: checklistsErrorMessage(state),
    responses: state.checklists.responses || [],
    readOnlyMode: readOnlyMode(state),
    periods: periods(state),
    selectedYear: selectedYear(state),
    scopeName: scopeName(state),
    enterpriseName: enterpriseName(state),
    currentBusinessUnit: currentBusinessUnit(state),
    planValidation: state.plans.planValidation,
  }),
  {
    fetchAnnualPlanComplianceContext,
    uploadChecklistAnswerEvidence: uploadChecklistAnswerEvidenceAction,
    resolveChecklistAnswerEvidence: resolveChecklistAnswerEvidenceAction,
    markFulfillmentVersionForApproval,
    getPlanValidation,
  },
)(Checklist);

export default ConnectedChecklist;
